module.exports = "../dist/img/product-detail-3-18.4119.jpg";